<template>
  <path pid="0" d="M19.92 6.84L9.62 17.13l-4.29-4.29a1 1 0 00-1.41 1.41l5 5a1 1 0 001.41 0l11-11a1 1 0 00-1.41-1.41z"/>
</template>
